import { Box, Flex } from '@chakra-ui/react';
import {
  Text,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@kula-ai/components';
import { LineChartDown02, LineChartUp02 } from '@kula-ai/icons-core';
import type { DashboardSection } from '../../../types';

// How sure the agent is — a rising green chart for high, a falling red one for
// low. Medium (and anything unmapped) shows nothing.
const CONFIDENCE_MARK: Record<
  string,
  { Icon: typeof LineChartUp02; color: string; label: string }
> = {
  high: {
    Icon: LineChartUp02,
    color: 'pastel-2-dark',
    label: 'High confidence',
  },
  low: {
    Icon: LineChartDown02,
    color: 'pastel-1-dark',
    label: 'Low confidence',
  },
};

const ConfidenceMark = ({ confidence }: { confidence: string }) => {
  const cfg = CONFIDENCE_MARK[confidence];
  if (!cfg) return null;
  const { Icon, color, label } = cfg;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Box as="span" color={color} display="inline-flex" aria-label={label}>
            <Icon size={16} />
          </Box>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export const SectionHeader = ({ section }: { section: DashboardSection }) => {
  if (!section.title && !section.confidence) return null;
  return (
    <Flex align="center" gap="8px" mb="10px">
      {section.title && (
        <Text
          variant="span"
          className="text-[14px] text-secondary-900 font-semibold"
        >
          {section.title}
        </Text>
      )}
      {section.confidence && <ConfidenceMark confidence={section.confidence} />}
    </Flex>
  );
};
